'use client'

import { Button } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { createHrefWithQuery } from '@repo/url/href'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FunctionComponent } from 'react'
import { subtypeFilterProperty } from 'services/refinement.service'
import { useRefinementUrl } from '../../../hooks/useRefinementUrl.hook'
import { CollectionDto } from '../../../types/collection.types'
import { PageDto } from '../../../types/page.types'

interface Props {
  pageDto: PageDto
  collectionDto: CollectionDto
  className?: string
}

const CollectionSubtypeFilter: FunctionComponent<Props> = ({ pageDto, collectionDto, className }) => {
  const pathname = usePathname()
  const { readOnlySearchParams, setRefinement, deleteRefinement } = useRefinementUrl()
  const subtypes = collectionDto.collection?.subtypeOptions || []

  // Return empty div to keep flexbox intact
  if (!collectionDto.collection?.availableFilters?.includes('subtype') || subtypes.length === 0) {
    return <div aria-hidden='true' />
  }

  return (
    <ol role='list' className={cn('py-1 lg:flex lg:flex-nowrap lg:overflow-x-auto lg:overflow-y-hidden', className)}>
      <li className='inline'>
        <Button variant={readOnlySearchParams.has(subtypeFilterProperty.id) ? 'ghostAuto' : 'outline'} asChild={true}>
          <Link href={createHrefWithQuery(pathname, deleteRefinement(subtypeFilterProperty.id))}>{pageDto?.dictionary?.filter?.all || 'All'}</Link>
        </Button>
      </li>
      {subtypes.map((subtype) => {
        const subtypeUrlSlug = String(subtype.urlSlug)
        const isActive = readOnlySearchParams.get(subtypeFilterProperty.id) === subtypeUrlSlug

        return (
          <li className='inline' key={subtype._id}>
            <Button variant={isActive ? 'defaultAuto' : 'ghostAuto'} asChild={true}>
              <Link href={createHrefWithQuery(pathname, isActive ? deleteRefinement(subtypeFilterProperty.id) : setRefinement(subtypeFilterProperty.id, subtypeUrlSlug))}>
                {subtype.title}
              </Link>
            </Button>
          </li>
        )
      })}
    </ol>
  )
}

export default CollectionSubtypeFilter
